<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="40"
      height="40"
      rx="20"
      fill="white"
    />
    <g clip-path="url(#clip0_3592_542)">
      <path
        d="M26.0001 14.6667H19.3334L18.6667 12.6667H14.0001C13.2667 12.6667 12.6667 13.2667 12.6667 14.0001V24.0001C12.6667 24.7334 13.2667 25.3334 14.0001 25.3334H19.3334L20.0001 27.3334H26.0001C26.7334 27.3334 27.3334 26.7334 27.3334 26.0001V16.0001C27.3334 15.2667 26.7334 14.6667 26.0001 14.6667ZM16.6667 22.6667C14.8267 22.6667 13.3334 21.1734 13.3334 19.3334C13.3334 17.4934 14.8267 16.0001 16.6667 16.0001C17.5667 16.0001 18.3201 16.3334 18.9001 16.8667L18.0201 17.7134C17.7667 17.4734 17.3267 17.1934 16.6667 17.1934C15.5067 17.1934 14.5667 18.1534 14.5667 19.3334C14.5667 20.5134 15.5067 21.4734 16.6667 21.4734C18.0067 21.4734 18.5601 20.5134 18.6134 19.8667H16.6667V18.7267H19.7867C19.8334 18.9334 19.8667 19.1334 19.8667 19.4067C19.8667 21.3134 18.5934 22.6667 16.6667 22.6667ZM20.7801 19.0534H23.2467C22.9601 19.8867 22.5067 20.6734 21.8801 21.3667C21.6734 21.1334 21.4801 20.8867 21.3067 20.6334L20.7801 19.0534ZM26.3334 25.6667C26.3334 26.0334 26.0334 26.3334 25.6667 26.3334H21.3334L22.6667 24.6667L21.9734 22.6001L24.0401 24.6667L24.6534 24.0534L22.4534 21.8867L22.4667 21.8734C23.2201 21.0401 23.7534 20.0801 24.0667 19.0601H25.3334V18.1934H22.3134V17.3334H21.4534V18.1934H20.4934L19.6401 15.6667H25.6667C26.0334 15.6667 26.3334 15.9667 26.3334 16.3334V25.6667Z"
        fill="#040325"
      />
    </g>
    <defs>
      <clipPath id="clip0_3592_542">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(12 12)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
